// import request from '@/api/backend/universal.js'
import request from '@/ajax' 	//TODO::
/**
 * 获取用户信息
 */	//TODO::
export function info() {
    return request('/user/userInfo');
}

/**
 * 修改用户信息，可以单独修改某一个字段
 * @param {Object} info
 */
export function save(info) {
    return request('/user/editUserInfo', info);
}
/**
 * 通过手机号修改密码
 *  * 
 * @param {String} phone  手机号
 * @param {String} code   验证码
 * @param {String} password  手机号
 * @param {String} rePassword   验证码
 */
export function register(info) {
    return request('/Authority/register', info);
}

/**
 * 通过手机号修改密码
 *  * 
 * @param {String} phone  手机号
 * @param {String} code   验证码
 * @param {String} password  手机号
 * @param {String} rePassword   验证码
 */
export function phoneModifyPassword(info) {
    return request('/user/phoneModifyPassword', info);
}
/**
 * 通过原密码修改密码
 *  * 
 * @param {String} oldPassword  手机号
 * @param {String} newPassword   验证码
 * @param {String} reNewPassword  手机号
 */
export function passwordModify(info) {
    return request('/user/passwordModify', info);
}

//换绑手机号
export function changePhone(query) {
    return request('/user/changePhone', query);
}

/**
 * 实名认证
 * @param {String} realname  真实姓名
 * @param {String} idcard    身份证号
 */
export function realAuth(realname, idcard) {
    return request('/user/certification', {
        realName: realname,
        idNumber: idcard,
    });
}
// 青少年模式
export function setAdolescent(query) {
    return request('/user/setAdolescent', query);
}
/**
 * 系统消息推送
 * @param {Boolean} isPush 是否推送通知
 */
export function pushNotice(isPush) {
    return request('/user/pushNotice', { is_push: isPush ? 1 : 0 });
}

// 我的礼包
export function giftOrderList(query) {
    return request('/gift/giftOrderList', query);
}
//我的消息
export function getNoticeCate(query) {
    return request('/notice/noticeCate', query);
}

//系统通知列表
export function getSystemList(query) {
    return request('/notice/sysNoticeList', query)
}

//游戏通知列表
export function gameNoticeList(query) {
    return request('/notice/gameNoticeList', query)
}
//绑定手机号
export function bindPhone(query) {
    return request('/user/changePhone', query);
}

//我的游戏
export function myGame(query) {
    return request('/user/myGame', query);
}

//我的关注
export function myFollow(query) {
    return request('/user/myFollow', query);
}
//移出我的游戏
export function cancelFollowGame(query) {
    return request('/user/cancelFollowGame', query);
}


//移出我的游戏
export function deleteMyGame(query) {
    return request('/user/deleteMyGame', query);
}

// 协议
export function getAgreementInfo(query) {
    return request('/common/agreementText', query);
}
/**
 * 注销账号
 * @param {String} phone  手机号
 * @param {String} code   验证码
 */
export function sendDisappearSms(query) {
    return request('/user/sendDisappearSms', query);
}
/**
 * 注销账号
 * 
 * @param {String} code   验证码
 */
export function disappear(query) {
    return request('/user/disappear', query);
}
/**
 * 取消注销
 */
export function canalDisappear() {
    return request('/user/canalDisappear');
}

export function userLogoffData() {
    return request('/user/userLogoffData');
}

// 获取客服地址
export function chatUrl() {
    return request('/common/chatUrl');
}

/**
 * 获取实名认证信息
 */
export function getRealNameInfo() {
    return request.get('/user/certified');
}


/**
 * 获取系统头像
 */
export function getSystemAvatars() {
    return request('/common/avatarList');
}

/**
 * 获取消息详情
 * @param {Number} id 消息ID
 */
export function getMessageDetail(query) {
    return request.get('/user/noticeInfo', {
        params: query,
    });
}

/**
 * 获取订单列表
 */
export function orderList(query) {
    return request('/market/orderList', query);
}

/**
 * 获取订单详情
 */
export function orderDetail(query) {
    return request('/market/orderDetail', query);
}

/**
 * 获取收藏列表
 */
export function goodsCollectList(query) {
    return request('/market/goodsCollectList', query);
}
/**
 * 取消收藏
 */
export function goodsUnCollect(query) {
    return request('/market/goodsUnCollect', query);
}

/**
 * 获取商品列表
 */
export function gameGoodsList(query) {
    return request('/market/gameGoodsList', query);
}
/**
 * 取消订单
 */
export function cancelOrder(query) {
    return request('/market/cancelOrder', query);
}

// 举报帖子、举报评论、举报用户
export function articletipoff(query) {
    return request('/article/tipoff', query);
}
//举报类型
export function tipoffTypeList(query) {
    return request('/article/tipoffTypeList', query)
}
//帖子关注列表
export function articleFollowList(query) {
    return request('/article/articleFollowList', query)
}

//我的帖子
export function myArticle(query) {
    return request('/article/myArticle', query);
}
//关注用户
export function followCustomer(query) {
    return request('/user/followCustomer', query);
}
//取消关注用户
export function cancelFollowCustomer(query) {
    return request('/user/cancelFollowCustomer', query);
}
//个人主页
export function userHomepage(query) {
    return request('/user/userHomepage', query);
}
//推荐用户
export function recommendUser() {
    return request('/user/recommendUser');
}
//获取关注列表
export function userFollow(query) {
    return request('/user/userFollow', query)
}
//获取粉丝列表
export function userFans(query) {
    return request('/user/userFans', query)
}

//我收藏的帖子列表
export function myCollectArticle(query) {
    return request('/article/myCollectArticle', query)
}

//我的点赞帖子列表
export function myLikeArticle(query) {
    return request('/article/myLikeArticle', query)
}


//社区助手列表
export function articleNoticeList(query) {
    return request('/notice/articleNoticeList', query)
}
//点赞收藏消息列表
export function likeCollectNoticeList(query) {
    return request('/notice/likeCollectNoticeList', query)
}
// 评论回复消息列表
export function commentNoticeList(query) {
    return request('/notice/commentNoticeList', query)
}

//站内信红点
export function noticeRedDot() {
    return request('/notice/noticeRedDot')
}


//角色列表
export function juheRoleList(query) {
    return request('/role/juheRoleList', query)
}

export function roleGameList() {
    return request('/game/roleGameList')
}

//我的预约
export function myReservationGameList() {
    return request('/game/myReservationGameList')
}

export function wishNoticeList() {
    return request('/notice/wishNoticeList')
}
// 获奖通知列表
export function winNoticeListApi() {
    return request('/notice/winNoticeList')
}

// 领取获奖通知奖励
export function receiveNoticeGiftApi(data) {
    return request('/gift/receiveNoticeGift', data)
}
//是否修改过生日
export function isModifyBirthday() {
    return request('/user/isModifyBirthday')
}
